import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  SHARED_SESSION_GRANT_ID_KEY,
  SHARED_SESSION_RESOURCE_TYPE_KEY,
} from './sharedAccountSession';

export const exchangeAndActivateSharedSessionGrant = createAsyncThunk(
  'sharedSession/exchangeAndActivateGrant',
  async ({ grantId, resourceType }: { grantId: string; resourceType: string }) => {
    // store grant ID and resource type in localStorage
    localStorage.setItem(SHARED_SESSION_GRANT_ID_KEY, grantId);
    localStorage.setItem(SHARED_SESSION_RESOURCE_TYPE_KEY, resourceType);

    // refresh the page to re-bootstrap the app
    window.location.reload();
  },
);
